/**
 * Created by denishuang on 2017/7/13.
 */
//
import Vue from 'vue'
import Vuex from 'vuex'
import store from 'vue-django/src/store'
Vue.use(Vuex)
Object.assign(store.state,
    {
        cachedViews: ['course_course_list', 'exam_exam_list', 'media_video_list', 'about_me', 'about_vendor', 'student_exam_paper_list'],
        continueViews: ['exam_paper_detail', 'media_video_detail', 'course_course_detail', 'exam_fault_list', 'exam_paper_favorite', 'exam_exam_detail', 'exam_exam_list'],
        qcloud: {
            vod: {
                appId: '1251357229'
            }
        },
        currentCourse:null,
        examPaperTagsOrder: `章节习题
每日一练
专项练习
历年真题
模拟真题
综合练习
配套习题`.split('\n').map((a,i) => [a, i]),
        examPaperReverseOrderTags: ['历年真题','模拟真题']
    })
Vue.set(store.state, 'todos', [])
Vue.set(store.state, 'fontSize', 16)
store.dispatch('getPartyInfo')
export default store



// WEBPACK FOOTER //
// ./src/store/index.js